import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, PhoneCall } from "lucide-react";

export default function CTASection() {
  return (
    <section className="py-24 sm:py-28" data-testid="cta-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="relative overflow-hidden rounded-3xl bg-ink text-white p-10 sm:p-16 grain">
          <div className="absolute -right-20 -top-20 h-80 w-80 rounded-full bg-terra/30 blur-3xl" />
          <div className="absolute -left-10 bottom-0 h-60 w-60 rounded-full bg-white/5 blur-3xl" />
          <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-7">
              <div className="eyebrow !text-white/60 mb-4">Start your campaign</div>
              <h2 className="font-display text-4xl sm:text-5xl font-bold tracking-tight">Ready to ship SEO and PR work the way agencies actually want it?</h2>
              <p className="mt-5 text-white/70 max-w-xl">Open a free account, place a first order in under 3 minutes, and have a real link building placement live within 14 days.</p>
            </div>
            <div className="lg:col-span-5 flex flex-col gap-3">
              <Link to="/signup" className="btn-primary justify-center text-base" data-testid="cta-signup">
                Create free account <ArrowUpRight size={18} />
              </Link>
              <Link to="/contact" className="inline-flex items-center justify-center gap-2 text-sm text-white/80 hover:text-white py-3 rounded-xl border border-white/15" data-testid="cta-strategy-call">
                <PhoneCall size={14} /> Book a strategy call
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
